import { render, staticRenderFns } from "./notification-IssueAssigned.vue?vue&type=template&id=c430f8b4&scoped=true"
import script from "./notification-IssueAssigned.vue?vue&type=script&lang=js"
export * from "./notification-IssueAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c430f8b4",
  null
  
)

export default component.exports